module.exports = __webpack_public_path__ + "619cf331871fb6cc9e3302c1dac82096.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-420.webp
// module id = 293
// module chunks = 0